var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStoreValue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.27567 1.33333H12.9997C13.1765 1.33333 13.3461 1.40357 13.4711 1.5286C13.5961 1.65362 13.6663 1.82319 13.6663 2V11.3333C13.6663 11.5101 13.5961 11.6797 13.4711 11.8047C13.3461 11.9298 13.1765 12 12.9997 12H0.999674C0.822863 12 0.653294 11.9298 0.52827 11.8047C0.403246 11.6797 0.333008 11.5101 0.333008 11.3333V0.666667C0.333008 0.489856 0.403246 0.320286 0.52827 0.195262C0.653294 0.0702379 0.822863 0 0.999674 0H5.94234L7.27567 1.33333ZM1.66634 1.33333V10.6667H12.333V2.66667H6.72367L5.39034 1.33333H1.66634ZM7.66634 6.66667H9.66634L6.99967 9.33333L4.33301 6.66667H6.33301V4H7.66634V6.66667Z",
    fill: "#6B6B6B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreValue);
export default __webpack_public_path__ + "static/media/storeValue.21a299e2260318adf824a93e732151f2.svg";
export { ForwardRef as ReactComponent };